export default function(key) {

    const strings = {
        cs: {
            dateNotFilled: `Nevyplnili jste datum nebo čas rezervace`,
            dateNotFuture: `Online rezervaci lze udělat minimálně 5 hodin před samotnou rezervací. Kontaktujte nás prosím na + 420 702 074 677.`,
        },
        en: {
            dateNotFilled: `You did not filled the date or time of the booking.`,
            dateNotFuture: `Online booking has to be done at least five hours before the booking itself. Please contact us on + 420 702 074 677.`,
        },
    };

    return strings[document.documentElement.lang][key];
}